import { render, staticRenderFns } from "./Admin.vue?vue&type=template&id=622b1dc9&scoped=true&"
import script from "./Admin.vue?vue&type=script&lang=js&"
export * from "./Admin.vue?vue&type=script&lang=js&"
import style0 from "./Admin.vue?vue&type=style&index=0&id=622b1dc9&lang=scss&scoped=true&"
import style1 from "./Admin.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622b1dc9",
  null
  
)

export default component.exports